<template>
	<div>
	</div>
</template>
<script>
	export default {
		name: "listitems",
		props: {
			type: {
				type: Number,
				default: 0,
			},
			index: {
				type: Number,
				default: 0,
			}
		},
		data () {
			return {};
		},
		methods: {
			godetail () {
				uni.$u.route({
					url: "/pages/gqxxdetail/gqxxdetail"
				})
			},
		}
	}
</script>
<style lang="less" scoped>
	.con1s {
		margin-right: 0px !important;
	}

	.con1 {
		width: 288px;
		height: 262px;
		background: #FFFFFF;
		border-radius: 10px;
		margin-bottom: 25px;
		margin-right: 17px;
		border: 1px solid rgba(0, 0, 0, 0.1);

		.con1_t {
			width: 100%;
			height: 63px;
			border-bottom: 1px solid #F5F5F5;

			.con1_l {
				width: 220px;
				height: 63px;
				padding-left: 9px;
				line-height: 63px;
				font-weight: 500;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				-o-text-overflow: ellipsis;
			}

			.con1_r {
				width: 44px;
				height: 26px;
				background: #E30E09;
				box-shadow: 0px 3px 6px 1px rgba(255, 0, 0, 0.18);
				border-radius: 5px 5px 5px 5px;
				font-weight: 500;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 26px;
				text-align: center;
				margin-left: 12px;
			}
		}

		.con1_c {
			width: 262px;
			margin: 0 auto;
			height: 146px;
			margin-top: 10px;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #202020;
			line-height: 28px;
			text-align: left;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			/*! autoprefixer: off */
			// 使用控制注释来禁用Autoprefixer
			-webkit-box-orient: vertical;
			/*autoprefixer: on */
			-webkit-line-clamp: 5;
			word-break: break-all;
		}

		.con1_b {
			width: 100%;
			height: 42px;
			border-top: 1px solid #F5F5F5;

			.con1_b_l {
				padding-left: 13px;
				font-weight: 400;
				font-size: 16px;
				color: rgba(0, 0, 0, 0.5);
			}

			.con1_b_r {
				margin-right: 13px;

				.con1_b_r_l {
					width: 18px;
					height: 12px;
					display: block;
					margin-right: 5px;
				}

				.con1_b_r_r {
					font-weight: 400;
					font-size: 16px;
					color: rgba(0, 0, 0, 0.5);
				}
			}
		}
	}
</style>